import { render, staticRenderFns } from "./LiveWaitStatusTag.vue?vue&type=template&id=861ee000&scoped=true"
import script from "./LiveWaitStatusTag.vue?vue&type=script&lang=js"
export * from "./LiveWaitStatusTag.vue?vue&type=script&lang=js"
import style0 from "./LiveWaitStatusTag.vue?vue&type=style&index=0&id=861ee000&prod&scoped=true&lang=css"
import style1 from "./LiveWaitStatusTag.vue?vue&type=style&index=1&id=861ee000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861ee000",
  null
  
)

export default component.exports